import React, { Component } from 'react'
import NavigatorMain from '../NavigatorMain';
import {
    hashHistory
} from 'react-router';
import { getJiaoYis } from "../../action/investmentAction"
import NHeader from "../NHeader.js";

export default class JaoYi extends Component {
    constructor(props) {
        super(props);
        this.state = {
          data:null,
          zhaunru:true,
          zhuanchu:false,
          dataVals: null,
          active:1,
        };
    }
    componentDidMount(){
        let dispatchs = this.props.location.state?this.props.location.state.dispatch:""
        let fundCodes = this.props.location.state?this.props.location.state.fundCode:""
        dispatchs && dispatchs(getJiaoYis(fundCodes, (result)=>{
          this.setState({
            dataVals: result
          })
        }))
      }
    goBack(){
        hashHistory.goBack();
    }
    choseTab(i){
        if(i=="1"){
            this.setState({
                zhaunru:true,
                zhuanchu:false
            })
        }else{
            this.setState({
                zhaunru:false,
                zhuanchu:true
            })
        }
        this.setState({
          active:i
        })
    }
  render() {
      let { dataVals, zhaunru } = this.state
    return (
      <div>
        <NavigatorMain>
            <NHeader title="交易规则" isPaddingBottom={0} />
        </NavigatorMain>
        <div lassName='content paddB40'>
            <div style={{flex:"1",overflow:"auto"}}>
                <div className='headerActive'>
                    <div style={{paddingTop:"5px"}}>
                        <div onClick={()=>this.choseTab(1)} style={{fontSize: "20px",fontWeight:"bold",color:this.state.active==1?'#FFFFFF':'rgba(255, 255, 255, 0.7)'}}>转入规则</div>
                        <div onClick={()=>this.choseTab(2)} style={{fontSize: "20px",fontWeight:"bold",color:this.state.active==2?'#FFFFFF':'rgba(255, 255, 255, 0.7)'}}>转出规则</div>
                    </div>
                    <div style={{display:"flex",paddingTop:"5px"}}>
                        <div style={{flex:1,textAlign:"center"}}><span className={this.state.active==1?'active':null}></span></div>
                        <div style={{flex:1,textAlign:"center"}}><span className={this.state.active==2?'active':null}></span></div>
                    </div>
                </div>
                <div style={{fontSize:"0.32rem",paddingTop:"0.1rem",paddingBottom:"0.1rem",backgroundColor:"#ffffff",paddingRight:"0.2rem",paddingLeft:"0.2rem"}}>{this.state.zhaunru?"转入时间":"转出时间"}</div>
                <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.1rem",color:"gray",fontSize:"0.2rem"}}>
                    <div style={{textAlign:"center"}}>
                    <div style={{fontSize:"0.24rem",paddingBottom:"0.05rem",paddingTop:"0.05rem",paddingLeft:"0.1rem",paddingRight:"0.1rem",backgroundColor:"#BF9B79",color:"#ffffff",borderRadius:"0.04rem",marginBottom: "-3px"}}>{this.state.zhaunru?"转入申请":"转出申请"}</div>
                    <img alt='' src={require('../../imgs/sanjiao@3x.png')} style={{width:'0.2rem',height:"0.2rem"}}/>
                    </div>
                    <div style={{textAlign:"center"}}>
                    <div style={{fontSize:"0.24rem",paddingBottom:"0.05rem",paddingTop:"0.05rem",paddingLeft:"0.1rem",paddingRight:"0.1rem",backgroundColor:"#BF9B79",color:"#ffffff",borderRadius:"0.04rem",marginBottom: "-3px"}}>开始确认交易</div>
                    <img alt='' src={require('../../imgs/sanjiao@3x.png')} style={{width:'0.2rem',height:"0.2rem"}}/>
                    </div>
                    <div style={{textAlign:"center"}}>
                    <div style={{fontSize:"0.24rem",paddingBottom:"0.05rem",paddingTop:"0.05rem",paddingLeft:"0.1rem",paddingRight:"0.1rem",backgroundColor:"#BF9B79",color:"#ffffff",borderRadius:"0.04rem",marginBottom: "-3px"}}>{this.state.zhaunru?"查看收益":"充值到货币"}</div>
                    <img alt='' src={require('../../imgs/sanjiao@3x.png')} style={{width:'0.2rem',height:"0.2rem"}}/>
                    </div>
                </div>
                <div style={{display:"flex",paddingLeft:"0.8rem",paddingRight:"0.8rem",backgroundColor:"#ffffff"}}>
                    <div style={{width:"0.1rem",borderRadius:"0.1rem",border:"0.02rem solid #BF9B79",height:"0.1rem"}}></div>
                    <div style={{flex:"1",borderBottom:"0.02rem solid #D6DAE4",marginBottom:"0.03rem"}}></div>
                    <div style={{width:"0.1rem",borderRadius:"0.1rem",border:"0.02rem solid #BF9B79",height:"0.1rem",marginLeft:zhaunru?0:"-0.12rem"}}></div>
                    <div style={{flex:"1",borderBottom:"0.02rem solid #D6DAE4",marginBottom:"0.03rem"}}></div>
                    <div style={{width:"0.1rem",borderRadius:"0.1rem",border:"0.02rem solid #BF9B79",height:"0.1rem",marginRight:zhaunru?0:"0.12rem"}}></div>
                </div>
                <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.1rem",fontSize:"0.24rem",color:"#818597"}}>
                        <div>{dataVals?dataVals.superFundConfirmAndIncomeDate.tradeDateString:""}</div>
                        <div>{zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.substring(5,dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.length):"":dataVals?dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.substring(5,dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.length):""}({zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyConfirmWeek:"":dataVals?dataVals.superFundConfirmAndIncomeDate.redeemConfirmWeek:""})</div>
                        <div>{zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.substring(5,dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.length):"":dataVals?dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.substring(5,dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.length):""}({zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyIncomeWeek:"":dataVals?dataVals.superFundConfirmAndIncomeDate.fundArrivalWeek:""})</div>
                </div>
                {
                    zhaunru?null:
                    <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.5rem",color:"gray",fontSize:"0.2rem"}}>
                        <div style={{textAlign:"center"}}>
                        <div style={{fontSize:"0.24rem",paddingBottom:"0.05rem",paddingTop:"0.05rem",paddingLeft:"0.1rem",paddingRight:"0.1rem",backgroundColor:"#BF9B79",color:"#ffffff",borderRadius:"0.04rem",marginBottom: "-3px"}}>{this.state.zhaunru?"转入申请":"转出申请"}</div>
                            <img alt='' src={require('../../imgs/sanjiao@3x.png')} style={{width:'0.2rem',height:"0.2rem"}}/>
                        </div>
                        <div style={{textAlign:"center"}}>
                        <div style={{fontSize:"0.24rem",paddingBottom:"0.05rem",paddingTop:"0.05rem",paddingLeft:"0.1rem",paddingRight:"0.1rem",backgroundColor:"#BF9B79",color:"#ffffff",borderRadius:"0.04rem",marginBottom: "-3px"}}>开始确认交易</div>
                            <img alt='' src={require('../../imgs/sanjiao@3x.png')} style={{width:'0.2rem',height:"0.2rem"}}/>
                        </div>
                        <div style={{textAlign:"center"}}>
                        <div style={{fontSize:"0.24rem",paddingBottom:"0.05rem",paddingTop:"0.05rem",paddingLeft:"0.1rem",paddingRight:"0.1rem",backgroundColor:"#BF9B79",color:"#ffffff",borderRadius:"0.04rem",marginBottom: "-3px"}}>{this.state.zhaunru?"查看收益":"资金到银行卡"}</div>
                            <img alt='' src={require('../../imgs/sanjiao@3x.png')} style={{width:'0.2rem',height:"0.2rem"}}/>
                        </div>
                    </div>
                }
                {
                    zhaunru?null:
                    <div style={{display:"flex",paddingLeft:"0.8rem",paddingRight:"0.8rem",backgroundColor:"#ffffff"}}>
                        <div style={{width:"0.1rem",borderRadius:"0.1rem",border:"0.02rem solid #BF9B79",height:"0.1rem"}}></div>
                        <div style={{flex:"1",borderBottom:"0.02rem solid #D6DAE4",marginBottom:"0.03rem"}}></div>
                        <div style={{width:"0.1rem",borderRadius:"0.1rem",border:"0.02rem solid #BF9B79",height:"0.1rem",marginLeft:zhaunru?0:"-0.24rem"}}></div>
                        <div style={{flex:"1",borderBottom:"0.02rem solid #D6DAE4",marginBottom:"0.03rem"}}></div>
                        <div style={{width:"0.1rem",borderRadius:"0.1rem",border:"0.02rem solid #BF9B79",height:"0.1rem",marginRight:zhaunru?0:"0.24rem"}}></div>
                    </div>
                }
                {
                    zhaunru?null:
                    <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.1rem",fontSize:"0.24rem",color:"#818597"}}>
                        <div>{dataVals?dataVals.superFundConfirmAndIncomeDate.tradeDateString:""}</div>
                        <div>{zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.substring(5,dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.length):"":dataVals?dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.substring(5,dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.length):""}({zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyConfirmWeek:"":dataVals?dataVals.superFundConfirmAndIncomeDate.redeemConfirmWeek:""})</div>
                        <div>{zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.substring(5,dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.length):"":dataVals?dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.substring(5,dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.length):""}({zhaunru?dataVals?dataVals.superFundConfirmAndIncomeDate.buyIncomeWeek:"":dataVals?dataVals.superFundConfirmAndIncomeDate.fundArrivalWeek:""})</div>
                    </div>
                }
                <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",paddingTop:"0.2rem",paddingBottom:"0.2rem",color:"gray",fontSize:"0.24rem"}}>
                    <div style={{paddingTop:"0.2rem",paddingBottom:"0.2rem",paddingLeft:"0.2rem",border:"0.02rem solid #D6DAE4",color:"#D6DAE4",backgroundColor:"#F6F7FA",flex:1,borderRadius:"0.1rem"}}>以上时间点仅供参考，具体以实际确认，到账时间为准</div>
                </div>
                <div style={{fontSize:"0.2rem",paddingTop:"0.1rem",paddingBottom:"0.1rem",backgroundColor:"#ffffff",paddingRight:"0.2rem",paddingLeft:"0.2rem",fontSize:"0.32rem",marginTop:"0.3rem"}}>{this.state.zhaunru?"转入费用":"转出费用"}</div>
                <div style={{paddingTop:"0.1rem",paddingBottom:"0.1rem",fontSize:"0.28rem",backgroundColor:"#ffffff",paddingLeft:"0.2rem",paddingRight:"0.2rem",lineHeight:"0.4rem"}}>
                    {this.state.zhaunru?
                   "本策略不重复收取申购费用。成分基金申购费率为0至1折。":
                   "据投顾账户持仓组合基金规定的赎回费收取。组合内成分基金若持有期小于7天，赎回将收取不低于1.5%的赎回费。"
                }
                </div>
                {
                    this.state.zhaunru?
                    <div>
                        <div style={{fontSize:"0.2rem",paddingTop:"0.1rem",paddingBottom:"0.1rem",backgroundColor:"#ffffff",paddingRight:"0.2rem",paddingLeft:"0.2rem",fontSize:"0.32rem",marginTop:"0.2rem"}}>投顾服务费率</div>
                        <div style={{display:"flex",paddingRight:"0.2rem",paddingLeft:"0.2rem",backgroundColor:"#ffffff",fontSize:"0.28rem",paddingBottom:"0.2rem",paddingTop:"0.2rem"}}>
                            <div style={{flex:1}}>投顾服务费率</div>
                            <div>{dataVals?dataVals.superFundManageRate.manageFeeRate:""}</div>
                        </div>
                    </div>
                    :null
                }
            </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/JaoYi.js